import React from 'react';
import {Link} from 'react-router-dom';
import {AppBar, IconButton, Toolbar} from '@material-ui/core';
import MenuIcon from '@material-ui/icons/Menu';
import {withStyles} from '@material-ui/core/styles';
import {styles, Classes} from '../styles';
import UserMenu from '../user-menu';
import Logo from 'feedback-system/app/assets/logo.png';

interface OwnProps {
    onToggleSidebar: () => void;
}

type IProps = Classes & OwnProps;

const Header = (props: IProps) => {
    const {classes, onToggleSidebar} = props;
    return (
        <AppBar position="fixed" className={classes.appBar}>
            <Toolbar className={classes.toolbar}>
                <IconButton
                    color="inherit"
                    onClick={onToggleSidebar}
                    className={classes.menuButton}>
                    <MenuIcon />
                </IconButton>
                <Link to="/">
                    <img src={Logo} alt="Feedback system" className={classes.logo} />
                </Link>
                <UserMenu/>
            </Toolbar>
        </AppBar>
    );
};

export default withStyles(styles)(Header);
